import { Admin } from "models/admin";
import { ListUser } from "models/list-user";
import { StateCreator } from "zustand";

export interface AuthSlice {
  authenticated: boolean;
  accessToken: string | undefined;
  refreshToken: string | undefined;

  // logged in user
  authAdmin: Admin | undefined;
  authListUser: ListUser | undefined;
}

export const createAuthSlice: StateCreator<
  AuthSlice,
  [],
  [],
  AuthSlice
> = () => ({
  authenticated: false,
  accessToken: undefined,
  refreshToken: undefined,
  authAdmin: undefined,
  authListUser: undefined,
});
